import React from 'react';
import classes from './Onboarding.module.css';

/**
 * OnboardingProgress
 * Renders a stepped progress indicator for the onboarding flow.
 *
 * @param {string[]} steps   - Array of step label strings
 * @param {number}   current - Zero-based index of the currently active step
 */
const OnboardingProgress = ({ steps = [], current = 0 }) => {
    return (
        <div className={classes.progressWrap}>
            {steps.map((label, idx) => {
                const isDone = idx < current;
                const isActive = idx === current;
                return (
                    <React.Fragment key={idx}>
                        {idx > 0 && (
                            <div
                                className={`${classes.stepConnector} ${isDone ? classes.done : ''}`}
                            />
                        )}
                        <div className={classes.step}>
                            <div className={classes.stepColumn}>
                                <div
                                    className={`${classes.stepDot} ${isActive ? classes.active : isDone ? classes.done : ''
                                        }`}
                                >
                                    {isDone ? '✓' : idx + 1}
                                </div>
                                <div
                                    className={`${classes.stepLabel} ${isActive ? classes.active : isDone ? classes.done : ''
                                        }`}
                                >
                                    {label}
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default OnboardingProgress;
